<template>
  <div class="m-0 p-0">
    <b-modal
      ref="processTransactionModal"
      body-class="p-0 m-0"
      hide-footer
      hide-header
      @ok="doProcessTransaction"
    >
      <div class="p-4 mt--4">
        <div class="form-control-label text-muted text-uppercase">
          Make Payment For
        </div>
        <h1 class="mb-4">
          {{ billingMembership.firstName }} {{ billingMembership.lastName }}'s
          Membership
        </h1>
        <div class="form-control-label">
          Amount
        </div>
        <validation-observer ref="formValidator" v-slot="{ handleSubmit }">
          <b-form
            role="form"
            @submit.prevent="handleSubmit(onProcessTransaction)"
          >
            <base-input
              name="Amount"
              v-model="amountBalance"
              rules="required|money"
            ></base-input>
            <b-button type="submit" class="btn btn-block mt-3" variant="primary"
              >Process Transaction</b-button
            >
          </b-form>
        </validation-observer>
      </div>
    </b-modal>

    <ask
      ref="askProcessBalance"
      title="Process Past Due Balance"
      @ok="processBalance"
      :message="
        'Are you sure you would like to process the past due balance of ' +
          this.$options.filters.currency(this.billingMembership.balance / 100) +
          '?'
      "
    ></ask>

    <ask
      ref="askToCancelModal"
      :title="cancelMembershipTitle"
      @ok="processActive()"
      :message="cancelMembershipMessage"
    ></ask>

    <b-modal
      ref="membershipModal"
      id="memberModal"
      body-class="p-0 m-0"
      hide-footer
      hide-header
    >
      <template #modal-header="{ close }">&nbsp;</template>

      <b-card
        :img-src="'img/membership/' + selectedMembership.imageId"
        img-alt="Image"
        img-top
        tag="article"
        style="max-width: 100%"
        class="mb-0"
      >
        <b-card-text>
          <h2>{{ selectedMembership.label }}</h2>
          <div class="text-muted">{{ selectedMembership.description }}</div>
          <hr class="mt-4 mb-2 p-0">
          <h3>Benefits</h3>
          <ul
            class="modal-benefits text-muted"
            v-for="item in selectedMembership.billingMembershipBenefits"
            v-bind:key="item.id"
          >
            <li>{{ item.label }}</li>
          </ul>
        </b-card-text>
        <b-button
          class="btn-block"
          variant="primary"
          @click="$refs.membershipModal.hide()"
          >Close</b-button
        >
      </b-card>
    </b-modal>

    <b-row class="m-0">
      <b-col class="modal-hero" style="padding-top: 15px !important;">
        <span class="status-pill status-pill-id"
          >ID {{ billingMembership.id }}</span
        >

        <span
          class="status-pill status-pill-active"
          v-if="billingMembership.status == 'ACTIVE'"
          >Active</span
        >
        <span
          class="status-pill status-pill-inactive"
          v-if="billingMembership.status == 'INACTIVE'"
          >Canceled
          {{ billingMembership.cancelledDate | moment("MM/DD/YYYY") }}
        </span>

        <span
          class="status-pill status-pill-waiting"
          v-if="billingMembership.status == 'AWAITINGPATIENT'"
          >Awaiting Completion
        </span>

        <div
          v-if="
            billingMembership.balance > 0 &&
              billingMembership.status == 'ACTIVE'
          "
          class="pb-3"
        >

          <b-row class="m-0 mb-2 light-alert light-alert-error" align-v="center">
            <b-col class="p-0">
              <i class="fa-solid fa-bell-on"></i>This membership plan has a past due balance of <strong>{{ (billingMembership.balance / 100) | currency }}</strong>
            </b-col>
            <b-col class="p-0 text-right">
              <b-button        v-if="hasRole('EDITMEMBERSHIPS')" variant="danger" @click.prevent="$refs.askProcessBalance.ask()">Process Past Due</b-button>
            </b-col>
          </b-row>

        </div>

        <b-card class="p-0 m-0 shadow-none">
          <b-row>
            <b-col class="pr-0 panel-divider panel-first">
              <div class="card-panel">
                <div class="stat-box-title">
                  {{ billingMembership.cycle | title }} Payment
                </div>
                <div class="stat-box-body">
                  {{ (billingMembership.amount / 100) | currency }}<br />

                  <span
                    class="pr-2"
                    v-if="billingMembership.status == 'AWAITINGPATIENT'"
                  >
                    <small
                      ><strong>
                        <a href="#" @click.prevent="notifyPatient"
                          ><i class="fa-solid fa-bell-on"></i> Send Reminder</a
                        >
                      </strong></small
                    >
                  </span>
                  <a
                    v-if="
                      billingMembership.status != 'INACTIVE' &&
                        hasRole('EDITMEMBERSHIPS')
                    "
                    @click.prevent="makeInActive"
                    href=""
                    class="cancel"
                    ><small
                      ><strong
                        ><i class="fa-solid fa-trash-can-xmark"></i> Cancel
                        Membership</strong
                      ></small
                    ></a
                  >
                </div>
              </div>
            </b-col>
            <b-col class="pl-0 pr-0 panel-divider">
              <div class="card-panel">
                <div class="stat-box-title">Start Date</div>
                <div class="stat-box-body">
                  <div v-if="billingMembership.awaitingPatientPastStartDate">
                    On Completion Date
                  </div>
                  <div v-else>
                    {{ billingMembership.startDate | moment("MM/DD/YYYY") }}
                    <i
                      v-if="billingMembership.status == 'AWAITINGPATIENT'"
                      class="title-icon fa-solid fa-circle-info"
                      v-b-tooltip.hover
                      title="If the patient doesn't complete their membership by the start date, the start date will be moved to when the patient completes their enrollment."
                    ></i>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col
              class="pl-0 pr-0 panel-divider"
              v-if="billingMembership.status == 'ACTIVE'"
            >
              <div class="card-panel">
                <div class="stat-box-title">Renewal Date</div>
                <div class="stat-box-body">
                  {{ billingMembership.nextBillingDate | moment("MM/DD/YYYY") }}
                </div>
              </div>
            </b-col>

            <b-col
              class="pl-0 pr-0 panel-divider"
              v-if="billingMembership.status == 'ACTIVE'"
            >
              <div class="card-panel text-right">
                <div class="stat-box-title"></div>
                <div class="stat-box-body">
                  <customer-saved-cards
                    :customer="customer"
                    ref="customerSavedCards"
                    title=" "
                    v-if="customer && billingMembership"
                    :selectCustomerSavedCardId="
                      billingMembership.customerSavedCardId
                    "
                    @onCustomerCardSelect="onCustomerCardSelect"
                    mode="2"
                    :showChangeCard="
                      billingMembership.status == 'ACTIVE' &&
                        hasRole('EDITMEMBERSHIPS')
                    "
                  ></customer-saved-cards>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row class="m-0">
      <b-col class="body-modal">
        <div>
          <b-row class="pb-2 m-0">
            <b-col cols="6" class="pl-0">
              <div class="form-control-label font-weight-bolder">Plan</div>
            </b-col>

            <b-col cols="2" style="text-align: right" class="pr-0">
              <div class="form-control-label font-weight-bolder">
                <b>{{ billingMembership.cycle | title }} Price</b>
              </div>
            </b-col>
            <b-col cols="2" style="text-align: right" class="pr-0">
              <div class="form-control-label font-weight-bolder">Qty</div>
            </b-col>
            <b-col cols="2" style="text-align: right" class="pr-0">
              <div class="form-control-label font-weight-bolder">Total</div>
            </b-col>
          </b-row>

          <div>
            <b-row
              class="m-0 border-bottom"
              v-for="membership in billingMembership.billingMemberships"
              v-bind:key="membership.id"
            >
              <b-col class="p-0 pt-2 pb-2" cols="6">
                 <a href="#" @click="showMembership(membership)"
                  ><small
                    ><strong>{{ membership.label }}</strong></small
                  ></a><br />
              </b-col>

              <b-col cols="2" style="text-align: right" class="pr-0 pt-2 pb-2">
                <small
                  ><strong class="text-muted">{{
                    (membership.amount / 100) | currency
                  }}</strong></small
                >
              </b-col>
              <b-col cols="2" style="text-align: right" class="pr-0 pt-2 pb-2">
                <small
                  ><strong class="text-muted">{{
                    membership.qty
                  }}</strong></small
                >
              </b-col>
              <b-col cols="2" style="text-align: right" class="pr-0 pt-2 pb-2">
                <small
                  ><strong class="text-muted">{{
                    ((membership.amount / 100) * membership.qty) | currency
                  }}</strong></small
                >
              </b-col>
            </b-row>
          </div>
        </div>

        <b-tabs
          class="mt-5"
          v-if="billingMembership.status != 'AWAITINGPATIENT'"
        >
          <b-tab title="Payment History">
            <payment-ledger
              :paymentLedgers="billingMembership.ledgerDtos"
              @rebind="bind"
            ></payment-ledger>
          </b-tab>
          <b-tab title="Authorization" v-if="billingMembership.method">
            <approval
              :method="billingMembership.method"
              :ipAddress="billingMembership.ipAddress"
              :signature="billingMembership.signature"
              :template="billingMembership.template"
              :approvedDate="billingMembership.approvedDate"
            ></approval>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Ask from "@/views/Components/Ask.vue";
import CustomerSavedCards from "@/views/Components/CustomerSavedCards";
import PaymentLedger from "@/views/Components/PaymentLedger";
import Approval from "@/views/Components/Approval";
export default {
  components: {
    ask: Ask,
    "customer-saved-cards": CustomerSavedCards,
    paymentLedger: PaymentLedger,
    approval: Approval,
  },
  inject: ["hasRole"],
  props: { id: null, setName: null },
  data() {
    return {
      selectedMembership: {},
      billingMembership: null,
      oldCard: null,
      cancelMembershipTitle: null,
      cancelMembershipMessage: null,
      cardSelected: null,
      customer: null,
      query: {
        statuses: ["APPROVED", "DECLINED"],
        modules: ["MEMBERSHIP"],
        customerBillingMembershipId: this.id,
      },
    };
  },
  methods: {
    async notifyPatient() {
      let r = await this.$client.post(
        "/api/customerMembershipBilling/notifyPatient",
        {
          id: this.billingMembership.id,
        }
      );

      if (r.data.isSuccess) {
        this.$emitter.emit("success", {
          title: "Notified",
          message:
            "The patient has been notified to complete their enrollment.",
        });
      }
    },
    async processBalance() {
      var self = this;

      let r = await this.$client.post(
        "/api/customerMembershipBilling/processPayment",
        {
          id: this.billingMembership.id,
          amount: this.billingMembership.balance,
        }
      );

      if (r.data.value.isApproved) {
        self.bind();
        self.$refs.processTransactionModal.hide();

        self.$emitter.emit("success-confirm", {
          title: "Transaction Approved",
          message: "Transaction ID: " + r.data.value.referenceId.split("-")[0],
        });
      } else {
        self.bind();
        self.$refs.processTransactionModal.hide();
        self.$emitter.emit("noSuccess-confirm", {
          title: "Transaction Declined",
          message: r.data.value.reason,
        });
      }
    },

    showMembership(membership) {
      this.selectedMembership = membership;
      this.$refs.membershipModal.show();
    },
    makeInActive() {
      if (this.billingMembership.billingMemberships.length == 1) {
        this.cancelMembershipMessage =
          "Memberships cannot be reactivated after cancellation. Would you like to proceed?";
        this.cancelMembershipTitle = "Cancel Membership";
      } else {
        this.cancelMembershipMessage =
          "Memberships cannot be reactivated after cancellation. Would you like to proceed?";
        this.cancelMembershipTitle = "Cancel Memberships";
      }
      this.$refs.askToCancelModal.ask();
    },

    onCustomerCardSelect(card) {
      this.cardSelected = card;
      this.processCard();
    },
    cancelNewCard() {
      this.$refs.customerSavedCards.selectCardId(this.oldCard.id);
    },
    async processActive() {
      var self = this;

      var r = await this.$client.post(
        "/api/customerMembershipBilling/setActive",
        { id: self.id, isActive: false }
      );

      if (r.data.isSuccess) {
        self.$emitter.emit("success-confirm", {
          title: "Canceled",
          message: "The membership plan has been canceled.",
        });
        await self.bind();
      }
    },
    async bind() {
      var self = this;
      let r = await self.$client.get(
        "/api/customerMembershipBilling/getCustomerMembershipBilling?id=" +
          self.id
      );
      self.billingMembership = r.data.value;

      self.customer = {
        id: self.billingMembership.customerId,
        firstName: self.billingMembership.firstName,
        lastName: self.billingMembership.lastName,
        email: self.billingMembership.eMail,
      };

      this.setName(self.customer.firstName + " " + self.customer.lastName);
    },
    processCard() {
      var self = this;

      this.$client
        .post("/api/customerMembershipBilling/setCustomerSavedCard", {
          customerSavedCardId: this.cardSelected.id,
          Id: self.id,
        })
        .then((r) => {
          if (r.data.isSuccess) {
            (self.billingMembership.customerSavedCardId = this.cardSelected.id),
              self.$emitter.emit("success-confirm", {
                title: "Card Attached",
                message:
                  "This card will be used for this membership going forward.",
              });
          }
        });
    },
  },

  async mounted() {
    this.bind();
  },
};
</script>

<style scoped>
#memberModal .modal-header {
  display: none;
}

.plan-background {
  padding: 30px;
  border-radius: 6px;
  background: #f6f9fc;
}

ul.modal-benefits,
ul.modal-benefits li {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
</style>
